import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	moreFields: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	showMoreFields: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	hideMoreFields: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	newLozenge: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	moreFields: {
		id: 'issue-create.modal.create-form.layout-renderer.fields-container.collapsible-area-header.more-fields',
		defaultMessage: 'More fields ({totalFields})',
		description:
			'Header button that displays the total amount of fields inside the collapsible area',
	},
	showMoreFields: {
		id: 'issue-create.modal.create-form.layout-renderer.fields-container.collapsible-area-header.show-more-fields',
		defaultMessage: '{totalFields, plural, one {Show one more field} other {Show # more fields}}',
		description:
			'Button a11y label that instructs user to show all fields inside the collapsible area',
	},
	hideMoreFields: {
		id: 'issue-create.modal.create-form.layout-renderer.fields-container.collapsible-area-header.hide-more-fields',
		defaultMessage: '{totalFields, plural, one {Hide one more field} other {Hide # more fields}}',
		description:
			'Button a11y label that instructs user to hide all fields inside the collapsible area',
	},
	newLozenge: {
		id: 'issue-create.modal.create-form.layout-renderer.fields-container.collapsible-area-header.new-lozenge',
		defaultMessage: 'New',
		description:
			'This is a Lozenge flag that will show next to the `More Fields` area. The user will see "More fields (1) [New]"',
	},
});
